var _effectorFileName = "/builds/gmini/front-ui-kit/src/WithSumIcon/WithSumIcon.tsx";
import { Box } from '../Box';
import { Sum } from '../icons/Sum';
import { SumWrapper } from './WithSumIcon.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WithSumIcon = ({
  icon
}) => /*#__PURE__*/_jsxs(Box, {
  width: "24px",
  height: "24px",
  position: "relative",
  children: [/*#__PURE__*/_jsx(SumWrapper, {
    children: /*#__PURE__*/_jsx(Sum, {})
  }), icon]
});